<template>
  <b-modal
    v-model="dataModal"
    centered
    no-close-on-backdrop
    no-close-on-esc
    title="Delete Comment"
    @close="onCloseModal">
    <div>
      Are you sure you want to delete the comment ?
    </div>
    <template #modal-footer>
      <call-button
        :icon="dataCloseIcon"
        type="danger"
        plain
        @click="onCloseModal()">
        Cancel
      </call-button>
      <call-button
        :icon="dataIconTrash"
        type="success"
        @click="clickDelete()">
        Delete
      </call-button>
    </template>
  </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue';
import CallButton from '../CallButton';
import { TASK_DELETE_COMMENT } from '../../../store/types/actions.types';
import iconsModal from '../../../mixins/iconsModal';
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { Notify } from 'vant';

export default {
  name: 'CallDeleteComment',
  components: {
    CallButton,
    BModal
  },
  mixins: [iconsModal],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    taskId: {
      type: [Number, String],
      default: null
    },
    commentId: {
      type: [Number, String],
      default: null
    }
  },
  data () {
    return {
      dataModal: this.value,
      dataIconTrash: faTrashAlt
    };
  },
  watch: {
    async value () {
      this.dataModal = this.value;
    }
  },
  methods: {
    onCloseModal () {
      this.$emit('input', false);
    },
    async clickDelete () {
      try {
        await this.$store.dispatch(`task/${TASK_DELETE_COMMENT}`, {
          taskId: this.taskId,
          commentId: this.commentId
        });
        if (this.$device.mobile) {
          Notify({ type: 'success', message: 'Comment successfully deleted' });
        } else {
          this.$Notify({
            title: 'Comment',
            message: 'Successfully deleted',
            type: 'success'
          });
        }
        this.onCloseModal();
        this.$emit('on-update');
      } catch (e) {
        throw Error('Ошибка блокировки');
      }
    }
  }
};
</script>
